import { applySnapshot, destroy, types,flow } from "mobx-state-tree";
import { IInput } from "../../utils/common-interface";
import customtypes from "../../utils/mobx-types-helper";
import { dataSdgHeader,dataSdgSub } from "../../constants";
import {
  ILoanProcessPlanDetailModel,
  ILoanProcessPlanModel,
  ILoanSourcesModel,
  ILoanTypePlanModel,
  LoanProcessPlanModel,
  LoanSourcePlanModel,
  LoanTypeModel,
  LoanTypePlanModel,
} from "./LoanModel";
import { ILOVModel } from "../org/OrganizeModel";


export interface IAmountObject {
  // ใช้สำหรับตอนทำ SignLoan View จาก loanTypePlans
  sourceType: string;
  amount: number;
  currencyCode: string;
  amountAsMillion: number;
}

export const ResultLOVSDGModel = types
  .model("ResultLOVSDGModel", {
    id: types.optional(types.number, 0),
    code: types.optional(types.string, ""), // (L = ในประเทศ , F = ต่างประเทศ, O = อื่นๆ)
    description: types.optional(types.string, ""),
    isSelected: types.optional(types.boolean, false),
  })
  .actions((self: any) => ({
    setField: ({ fieldname, value }: IInput) => {
      self[fieldname] = value;
    },
  }));

export type IResultLOVSDGModel = typeof ResultLOVSDGModel.Type;

export const ResultLOVOrNullModel = types
  .model("ResultLOVOrNullModel", {
    id: types.maybeNull(types.number),
    code: types.maybeNull(types.string), // (L = ในประเทศ , F = ต่างประเทศ, O = อื่นๆ)
    description: types.maybeNull(types.string),
    isSelected: types.maybeNull(types.boolean),
  })
  .actions((self: any) => ({
    setField: ({ fieldname, value }: IInput) => {
      self[fieldname] = value;
    },
  }));

export type IResultLOVOrNullModel = typeof ResultLOVOrNullModel.Type;

export const AmountSDGModel = types
  .model("AmountSDGModel", {
    sdgAmountID: types.maybeNull(types.number),
    sourceType: customtypes.optional(types.string, ""), // (L = ในประเทศ , F = ต่างประเทศ, O = อื่นๆ)
    amount: customtypes.optional(types.number, 0),
    currencyCode: customtypes.optional(types.string, ""),
    thbAmount: customtypes.optional(types.number, 0),
    sourceLoan: types.optional(ResultLOVSDGModel, {}),
  })
  .views((self: any) => ({
    get mAmount() {
      return self.amount / 1000000;
    },
  }))
  .actions((self: any) => ({
    setField: ({ fieldname, value }: IInput) => {
      self[fieldname] = value;
    },
  }));
export type IAmountSDGModel= typeof AmountSDGModel.Type;

export const yearPlanSDGModel = types
  .model("yearPlanSDGModel", {
    projYearPlanSDGID: types.maybeNull(types.number),
    year: customtypes.optional(types.union(types.number, types.string), ""),
  })
  .views((self: any) => ({
   //
  }))
  .actions((self: any) => ({
    setField: ({ fieldname, value }: IInput) => {
      self[fieldname] = value;
    },
  }));
export type IyearPlanSDGModel= typeof yearPlanSDGModel.Type;

export const SDGsSubModel = types
    .model("SDGsSubModel", {
      sdgSubDetailID: types.maybeNull(types.number),
      sdgKey: types.maybeNull(types.number),
      isAccord: types.optional(types.boolean, false),
      topic: customtypes.optional(types.string, ""),//ข้อ sdgs มาจาก LOV Remark
      code: customtypes.optional(types.string, ""),//ข้อ sdgs มาจาก LOV code
      description: customtypes.optional(types.string, ""),//ข้อ sdgs มาจาก LOV value
      percent: customtypes.optional(types.number, 0),
      thbAmount: customtypes.optional(types.number, 0),
      amounts: types.optional(types.array(AmountSDGModel), [
      ]),
    })
    .views((self: any) => ({
        //
    }))
    .actions((self: any) => ({
        setField: ({ fieldname, value }: IInput) => {
            self[fieldname] = value;
        },
    }));
export type ISDGsSubModel = typeof SDGsSubModel.Type;

export const SDGDetailModel = types
  .model("SDGDetailModel", {
    sdgDetailID: types.maybeNull(types.number),
    sdgKey: types.maybeNull(types.number),
    isAccord: types.optional(types.boolean, false),
    topic: customtypes.optional(types.string, ""),//ข้อ sdgs มาจาก LOV Remark
    code: customtypes.optional(types.string, ""),//ข้อ sdgs มาจาก LOV Remark
    description: customtypes.optional(types.string, ""),//ข้อ sdgs มาจาก LOV value
    percent: customtypes.optional(types.number, 0),
    thbAmount: customtypes.optional(types.number, 0),
    amounts: types.optional(types.array(AmountSDGModel), [
    ]),
    sdgSubs:  types.maybeNull(types.array(SDGsSubModel)),
  })
  .views((self: any) => ({
    get AmountsSorted() {
      return [
        ...self.amounts
      ];
    },
    get sdgJSON() {
      return self.toJSON();
    },
  }))
  .actions((self: any) => ({
    onAddForeignAmount: (
      fieldname: "amounts",
      sourceType: String | "F",
    ) => {
      self[fieldname].push({
        sourceType: sourceType,
        currencyCode: "USD"
      });
    },
    onAddSourceLoan: (sourceLoan: IResultLOVSDGModel) => {
      console.log('sourceLoan onAddSourceLoan',sourceLoan)
      self['amounts'].push({
        sourceType: 'L',
        currencyCode: "THB",
        sourceLoan:sourceLoan
        // sourceLoan,
      });
      console.log('self[amounts',self['amounts'])
    },
    onRemoveAmount: (amount: IAmountSDGModel) => {
      destroy(amount);
    },
    onRemoveForeignAmount: (amount: IAmountSDGModel) => {
      destroy(amount);
    },
    setField: ({ fieldname, value }: IInput) => {
      self[fieldname] = value;
    },
    setAllField: (data: any) => {
      Object.keys(data).forEach((key) => {
        try {
          self[key] = data[key];
        } catch (e) {
          console.log("exception on mapping key SDGDetailModel:", key);
        }
      });
    },
    resetAll: () => {
      applySnapshot(self, {});
    },
  }));
export type ISDGDetailModel = typeof SDGDetailModel.Type;

